import { defineMessages } from 'react-intl';
import { MessagesList } from '../../../types/Message';

export const messages: MessagesList = defineMessages({
  descriptionLabel: {
    id: 'account.quotes.form.label.description',
    defaultMessage: 'Describe the desired end result',
  },
  descriptionDescription: {
    id: 'account.quotes.form.helptext.description',
    defaultMessage: 'Describe the desired end result as concretely as possible. Consider aspects such as finishing, type of paper, etc.',
  },
});
